import { FieldHasValue } from 'helpers/Validation';

export const AsFoundResultFormulaP611 = (formData) => {
    if (FieldHasValue(formData.F440AftForcedOutputsignal) && FieldHasValue(formData.F441AftConfirmContactorOperates)) {
        if (formData.F440AftForcedOutputsignal === 'YES' && formData.F441AftConfirmContactorOperates === 'YES') {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
